<div class="user-preferences-view-container container" fxLayout="column" fxLayoutGap="15px">
  <div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <h2 class="mat-h2 color-primary text-small-caps no-bottom-margin">{{ 'userPreferences.title' | translate }}</h2>
      <mtn-what-is-this [text]="'userPreferences.description' | translate"></mtn-what-is-this>
    </div>
    <hr/>
  </div>
  <div>
    <mtn-key-value [key]="'userPreferences.keyIndicator' | translate" [ngSwitch]="userPreferences?.primaryKeyIndicator">
      <span *ngSwitchCase="KeyIndicatorType.SALES_SQFT">{{ 'userPreferences.salesSqft' | translate }}</span>
      <span *ngSwitchCase="KeyIndicatorType.SALES_VOLUME">{{ 'userPreferences.salesVolume' | translate }}</span>
      <span *ngSwitchDefault class="color-muted">{{ 'userPreferences.notAvailable' | translate }}</span>
    </mtn-key-value>

    <mtn-key-value [key]="'userPreferences.mapType' | translate" [ngSwitch]="userPreferences?.mapDefaultType">
      <span *ngSwitchCase="MapTypeId.HYBRID">{{ 'userPreferences.satellite' | translate }}</span>
      <span *ngSwitchCase="MapTypeId.ROADMAP">{{ 'userPreferences.road' | translate }}</span>
      <span *ngSwitchDefault class="color-muted">{{ 'userPreferences.notAvailable' | translate }}</span>
    </mtn-key-value>

    <mtn-key-value [key]="'userPreferences.mapTypeRoad' | translate" [ngSwitch]="userPreferences?.mapDefaultMode">
      <span *ngSwitchCase="MapMode.CLASSIC">{{ 'userPreferences.classic' | translate }}</span>
      <span *ngSwitchCase="MapMode.DARK">{{ 'userPreferences.dark' | translate }}</span>
      <span *ngSwitchDefault class="color-muted">{{ 'userPreferences.notAvailable' | translate }}</span>
    </mtn-key-value>

    <mtn-key-value [key]="'userPreferences.salesVolumeDisplay' | translate" [ngSwitch]="userPreferences?.salesVolumeDisplayMode">
      <span *ngSwitchCase="SalesVolumeDisplayModeType.ANNUAL">{{ 'userPreferences.annualSales' | translate }}</span>
      <span *ngSwitchCase="SalesVolumeDisplayModeType.WEEKLY">{{ 'userPreferences.weeklySales' | translate }}</span>
      <span *ngSwitchDefault class="color-muted">{{ 'userPreferences.notAvailable' | translate }}</span>
    </mtn-key-value>

    <mtn-key-value [key]="'userPreferences.salesSqftDisplay' | translate" [ngSwitch]="userPreferences?.salesSqftDisplayMode">
      <span *ngSwitchCase="SalesSqftDisplayModeType.SALES_AREA">{{ 'userPreferences.salesArea' | translate }}</span>
      <span *ngSwitchCase="SalesSqftDisplayModeType.TOTAL_AREA">{{ 'userPreferences.totalArea' | translate }}</span>
      <span *ngSwitchDefault class="color-muted">{{ 'userPreferences.notAvailable' | translate }}</span>
    </mtn-key-value>
  </div>
  <mtn-spinner [on]="isLoading"></mtn-spinner>
</div>
